import type StatusObject from '@/classes/SubmissionStatuses/StatusObject'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'
import { toTitleCase } from '@/classes/SubmissionStatuses/statusUtils'
import {
	type EverplansSubmissionStatus,
	type SubmissionAction,
} from '@/classes/SubmissionStatuses/types'

export abstract class BaseEverplansStatus implements StatusObject {
	submissionStatus: EverplansSubmissionStatus

	constructor(submissionStatus: EverplansSubmissionStatus) {
		this.submissionStatus = submissionStatus
	}

	getVendorName() {
		return 'Everplans'
	}

	getUpdatedAt() {
		return this.submissionStatus.updatedAt
	}

	getActions(): Array<SubmissionAction> {
		return []
	}

	getStatusText() {
		return toTitleCase(this.submissionStatus.status)
	}

	getToolTipText() {
		return {
			title: this.getVendorName() + ' ' + this.getStatusText(),
			body: '',
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.INACTIVE
	}
}
